import { t } from "i18next";

const settingsPages = [
    {title: t('dashboard.basicInformation.title'), value: 'basicInformation'},
    {title: t('dashboard.appearance.title'), value: 'appearance'},
    {title: t('dashboard.banners.title'), value: 'banners'},
    {title: t('dashboard.description.title'), value: 'descriptionBlock'},
    {title: t('dashboard.newsletter.title'), value: 'newsletter'},
    {title: t('dashboard.footer.title'), value: 'footer'},
]

export default settingsPages;